//import React from "react";
import ErrorBoundary from "./ErrorBoundary";

function Main({ children }) {
  return (
    <main className="h-full dark:bg-black">
      <div className="2xl:container lg:mx-auto grid h-full relative overflow-y-auto">
        <ErrorBoundary>{children}</ErrorBoundary>
      </div>
    </main>
  );
}

export default Main;
